<div class="dialog-text">{{titleModal}}</div>
<button class="btn btn--outline" (click)="cancelEvent()">{{textCancel}}</button>
<button class="btn" (click)="submitEvent()">{{textSubmit}}</button>
